import React from 'react';
import { Router, Route, IndexRoute } from 'react-router';
import { Provider } from 'react-redux';

import App from './App';
import Home from './components/containers/Home';
import LoginContainer from './components/containers/Login';


/** CLIENT COMPONENTS **/
import Clients from './components/containers/Clients';
import ClientsList from './components/presentation/clients/ClientsList';


/** REPORTS COMPONENTS **/
import Reports from './components/containers/Reports';
import ProductsReport from './components/presentation/reports/ProductsReport';
import EvaluationsReport from './components/presentation/reports/EvaluationsReport';
import SurveysReport from './components/presentation/reports/SurveysReport';
import AccompanimentReport from './components/presentation/reports/AccompanimentReport';
import Dashboard from './components/presentation/reports/Dashboard';

/** Users **/
import Users from './components/containers/Users';
import UsersIndex from './components/presentation/users/UsersIndex';


/** SaleSupport **/
import SaleSupport from './components/containers/SaleSupport';
import SaleSupportIndex from './components/presentation/support/SaleSupportIndex';

/** SaleSupport **/
import Communiques from './components/containers/Communiques';
import CommuniquesIndex from './components/presentation/communiques/CommuniquesIndex';
import CommuniqueForm from './components/presentation/communiques/CommuniqueForm';

/** Uploads **/
import Uploads from './components/containers/Uploads';
import UploadsIndex from './components/presentation/uploads/UploadsIndex';
import UploadsShow from './components/presentation/uploads/UploadsShow';

import { store, history } from './store';

import { requireAuth, onlyGuest} from './utils/routing-hooks';

const router =
    <Provider store={store}>
        <Router history={history}>
            <Route path="/" component={App} name="Inicio">
                <IndexRoute component={Home} onEnter={requireAuth(store)}/>
                <Route path="login" name="Inicio de sesión" component={LoginContainer} onEnter={onlyGuest(store)}/>
                <Route path="uploads" name="Cargas" component={Uploads} onEnter={requireAuth(store)}>
                    <Route path=":uploadID" component={UploadsShow} name="Detalle" />
                    <IndexRoute component={UploadsIndex} />
                </Route>

                <Route path="clients" component={Clients} name="cargas">
                    <IndexRoute component={ClientsList} />
                </Route>

                <Route path="users" component={Users} name="Usuarios">
                    <IndexRoute component={UsersIndex} />
                </Route>
                <Route path="reports" component={Reports} name="Reportes" onEnter={requireAuth(store)}>
                    <Route path="products" component={ProductsReport} name="Productos"/>
                    <Route path="evaluations" component={EvaluationsReport} name="Evaluaciones" />
                    <Route path="surveys" component={SurveysReport} name="Encuestas" />
                    <Route path="accompaniment" component={AccompanimentReport} name="Acompañamiento" />
                    <IndexRoute component={Dashboard} />
                </Route>

                
                <Route path="sale-support" component={SaleSupport} name="Apoyo a la venta" onEnter={requireAuth(store)}>
                    <IndexRoute component={SaleSupportIndex}/>
                </Route>

                <Route path="communiques" component={Communiques} name="Comunicados" onEnter={requireAuth(store)}>
                    <Route path="create" component={CommuniqueForm} name="Crear nuevo" />
                    <IndexRoute component={CommuniquesIndex}/>
                </Route>
            </Route>
        </Router>
    </Provider>

export default router;



/** WEBPACK FOOTER **
 ** ./src/router.jsx
 **/